export const PEOPLE_TO_SHOW = 10;
